module.exports = __webpack_public_path__ + "img/logo_sp-white.1fd896cb.svg";